import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";
import {
  BookOpen,
  Globe,
  Award,
  TrendingUp,
  Users,
  BriefcaseBusiness,
  Plane,
  House,
  Computer,
  Contact,
  HouseIcon,
  PlaneIcon, // Importado para intercambio cultural
} from "lucide-react";

import DataFetcherGlobal from "../../hooks/DataFetcherGlobal";

const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/template_home/50e880e8-000f-428c-91f7-73c3b4ec7645" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_imagen14.field_media_image,field_imagen15.field_media_image,field_imagen28.field_media_image,field_imagen29.field_media_image,field_imagen30.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30,field_bloque31," +
  "field_imagen13,field_imagen14,field_imagen15,field_imagen28,field_imagen29,field_imagen30" +
  "&fields[media--image]=field_media_image";

function Internacional() {
  const DataDisplay = ({ data }) => {
    // Array que mapea cada bloque (1 al 4) con su contenido HTML y un icono coherente de Lucide
    const bloquesConIcono = [
      { __html: data.bloque1, icon: Globe }, // Movilidad académica y científica
      { __html: data.bloque2, icon: Users }, // Intercambio cultural e idiomas
      { __html: data.bloque3, icon: Award }, // Colaboraciones estratégicas
      { __html: data.bloque4, icon: TrendingUp }, // Visibilidad internacional
    ];

    const brochure = [
      { __html: data.bloque6, icon: Globe },
      { __html: data.bloque7, icon: Users },
      { __html: data.bloque8, icon: Award },
    ];

    const bloquesCurriculo = [
      { __html: data.bloque21, icon: Globe },
      { __html: data.bloque22, icon: Users },
      { __html: data.bloque23, icon: PlaneIcon },
      { __html: data.bloque24, icon: HouseIcon },
    ];

    return (
      <div>
        {/* HERO */}
        <section className="relative bg-gradient-to-br from-[#003358] via-[#004270] to-[#005591] py-24 text-center overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(254,190,16,0.08),transparent_50%)] pointer-events-none" />

          <div
            className="relative max-w-6xl m-auto px-6 sm:px-4 lg:px-0 mt-16
      [&_h2]:text-white
      [&_h2]:text-4xl
      [&_h2]:font-bold
      [&_h2_strong]:text-[#febe10]
      [&_h2_strong]:text-6xl
      [&_h2_strong]:font-extrabold
      [&_h2_strong]:border-b-4
      [&_h2_strong]:border-[#febe10]
      [&_h4]:text-white
      [&_p]:text-white"
          >
            <div
              className="max-w-3xl m-auto [&_p]:text-2xl"
              dangerouslySetInnerHTML={{
                __html: data.texto_portada,
              }}
            />

            <div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
                {bloquesConIcono.map((item, index) => {
                  const IconComponent = item.icon;
                  return (
                    <div
                      key={index}
                      className="bg-white/[0.07] backdrop-blur-md p-6 rounded-xl border border-white/10 shadow-lg hover:bg-white/[0.1] transition-all duration-300 flex flex-col items-center text-center group"
                    >
                      {IconComponent && (
                        <div className="w-14 h-14 bg-white/10 rounded-full flex items-center justify-center mb-4 text-[#febe10] group-hover:scale-110 transition-transform duration-300">
                          <IconComponent size={26} />
                        </div>
                      )}
                      <div
                        className="link-arrow-down [&_a]:text-white!important"
                        dangerouslySetInnerHTML={{
                          __html: item.__html,
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>

        <section id="convocatoria" className="bg-gray-50 py-16">
          <div
            className="text-center px-4 max-w-3xl m-auto mb-4"
            dangerouslySetInnerHTML={{
              __html: data.bloque31,
            }}
          />

          <DataFetcherGlobal></DataFetcherGlobal>
        </section>

        {/* BROCHURE */}
        <section className="py-4">
          <div className="max-w-6xl mx-auto px-6 sm:px-4 lg:px-0 my-10 ">
            <div className="flex flex-col lg:flex-row gap-8 items-center  bg-gray-100 rounded-3xl p-8 sm:p-12 border border-slate-200 shadow-sm relative overflow-hidden">
              <div className="flex-[7] w-full">
                <div
                  className="[&_h3]:uppercase
                [&_h3]:text-base
                [&_h3]:p-0
                  [&_h3_strong]:text-base
                "
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque5,
                    }}
                  />
                </div>

                <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                  {brochure.map((item, index) => {
                    const IconComponent = item.icon;
                    return (
                      <div
                        key={index}
                        className="bg-white p-4 rounded-xl border border-gray-200 shadow-xs "
                      >
                        {IconComponent && (
                          <div className="mb-4 w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center text-[#febe10]">
                            <IconComponent size={24} />
                          </div>
                        )}
                        <div
                          className="
                        [&_h4]:p-0
                        [&_h4]:text-lg
                          [&_p]:text-xs
                        [&_h4_strong]:text-lg"
                          dangerouslySetInnerHTML={{
                            __html: item.__html,
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="flex-[3] w-full bg-white/5  rounded-lg border border-white/10">
                <div className="   bg-white p-4 rounded-xl border border-gray-200 shadow-xs">
                  <div className="mb-4 w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center text-[#004270]">
                    <BookOpen size={30} />
                  </div>
                  <div
                    className="link-1
                  "
                    dangerouslySetInnerHTML={{
                      __html: data.bloque9,
                    }}
                  />{" "}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* PASAPORTE AL MUNDO */}
        <section id="movilidad" className="bg-slate-50 py-24">
          <div className="max-w-6xl mx-auto px-6 sm:px-4 lg:px-0   ">
            <div
              className="text-center max-w-3xl m-auto"
              dangerouslySetInnerHTML={{
                __html: data.bloque10,
              }}
            />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-10">
              <div className=" bg-white p-4 rounded-xl border border-gray-200 shadow-xs">
                <div className="mb-4 w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center text-[#004270]">
                  <BriefcaseBusiness size={30} />
                </div>
                <div
                  className="
                  [&_ul]:border-t-2    
                  [&_ul]:border-gray-200
                   [&_ul]:pt-4
                    [&_li]:text-gray-600
                    [&_li]:text-sm"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque11,
                  }}
                />
              </div>

              <div className=" bg-white p-4 rounded-xl border border-gray-200 shadow-xs">
                <div className="mb-4 w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center text-[#004270]">
                  <Plane size={30} />
                </div>
                <div
                  className="
                  [&_ul]:border-t-2    
                  [&_ul]:border-gray-200
                   [&_ul]:pt-4
                    [&_li]:text-gray-600
                    [&_li]:text-sm"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque12,
                  }}
                />{" "}
              </div>
            </div>
          </div>
        </section>

        {/* INTERCAMBIOS */}
        <section id="intercambio" className="py-24">
          <div className="max-w-6xl mx-auto px-6 sm:px-4 lg:px-0   ">
            <div
              className="[&_h3]:uppercase
                [&_h3]:text-base
                [&_h3]:p-0
                  [&_h3_strong]:text-base"
              dangerouslySetInnerHTML={{
                __html: data.bloque13,
              }}
            />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-10">
              <div className=" bg-white p-4 rounded-xl border-2 border-[#004270] shadow-xs">
                <div className="mb-4 w-14 h-14 bg-[#004270] rounded-lg flex items-center justify-center text-white">
                  <House size={24} />
                </div>
                <div
                  className="
             [&_ul]:rounded-3xl
                  [&_ul]:bg-gray-50
                   [&_ul]:p-6
                    [&_li]:text-gray-600
                    [&_li]:text-sm"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque14,
                  }}
                />
              </div>

              <div className=" bg-white p-4 rounded-xl border-2 border-[#004270] shadow-xs">
                <div className="mb-4 w-14 h-14 bg-[#004270] rounded-lg flex items-center justify-center text-white">
                  <Computer size={24} />
                </div>
                <div
                  className="
               [&_ul]:rounded-3xl
                  [&_ul]:bg-gray-50
                   [&_ul]:p-6
                    [&_li]:text-gray-600
                    [&_li]:text-sm"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque15,
                  }}
                />{" "}
              </div>
            </div>
            {/*requisitos */}
            <div className="bg-gray-50 p-8 my-10 rounded-3xl border border-slate-100 shadow-sm">
              <div
                className="mb-6 [&_h3]:text-xl [&_h3]:font-bold [&_h3]:text-[#004270]"
                dangerouslySetInnerHTML={{
                  __html: data.bloque16,
                }}
              />

              <div
                className="
      [&_ul]:grid 
      [&_ul]:grid-cols-1 
      [&_ul]:md:grid-cols-2 
      [&_ul]:lg:grid-cols-3 
      [&_ul]:gap-4 
      [&_ul]:list-none 
      [&_ul]:p-0 
      [&_li]:bg-white
      [&_li]:p-4 
      [&_li]:rounded-xl 
      [&_li]:border 
      [&_li]:border-slate-200/60 
      [&_li]:text-sm 
      [&_li]:text-gray-700
  [&_li]:before:content-none
  "
                dangerouslySetInnerHTML={{
                  __html: data.bloque17,
                }}
              />
            </div>

            {/* contacto */}

            <div className="flex flex-col lg:flex-row gap-4 items-center  bg-white rounded-3xl p-4 border border-slate-200 shadow-sm relative overflow-hidden">
              <div className="flex-[1] w-full">
                <div className="mb-4 w-14 h-14 bg-[#004270] rounded-lg flex items-center justify-center text-white">
                  <Contact size={24} />
                </div>
              </div>
              <div className="flex-[6] w-full">
                <div>
                  <div
                    className="[&_h4]:p-0"
                    dangerouslySetInnerHTML={{
                      __html: data.bloque18,
                    }}
                  />
                </div>
              </div>

              <div className="flex-[3] w-full bg-white/5  rounded-lg border border-white/10">
                <div
                  className="[&_p]:p-0
                      [&_p]:text-gray-500"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque19,
                  }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* CURRICULO */}
        <section id="curriculo" className=" py-24 bg-[#004270]">
          <div className="max-w-6xl mx-auto px-6 sm:px-4 lg:px-0   ">
            <div
              className="[&_h2]:text-white max-w-3xl m-auto text-center
              [&_h3]:uppercase
                [&_h3]:text-base
                 [&_h3]:text-white
                [&_h3]:p-0
                  [&_h3_strong]:text-base
                    [&_p]:text-white
                  "
              dangerouslySetInnerHTML={{
                __html: data.bloque20,
              }}
            />

            <div className="grid grid-cols-1 sm:grid-cols-2  lg:grid-cols-4 gap-6 mt-10">
              {bloquesCurriculo.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div
                    key={index}
                    className="bg-white/[0.07] backdrop-blur-md p-6 rounded-xl border border-white/10 shadow-lg hover:bg-white/[0.1] transition-all duration-300 flex flex-col items-center text-center group"
                  >
                    {IconComponent && (
                      <div className="w-14 h-14 bg-white/10 rounded-full flex items-center justify-center mb-4 text-[#febe10] group-hover:scale-110 transition-transform duration-300">
                        <IconComponent size={26} />
                      </div>
                    )}
                    <div
                      className="
                      [&_p]:text-white
                      [&_h3]:text-white
                       [&_h3_strong]:text-lg
                      [&_h3_strong]:text-[#febe10]
                      "
                      dangerouslySetInnerHTML={{
                        __html: item.__html,
                      }}
                    />
                  </div>
                );
              })}
            </div>

            <div className=" mt-10 flex flex-col lg:flex-row gap-4 items-center  bg-white rounded-3xl p-4 border border-slate-200 shadow-sm relative overflow-hidden">
              <div className="flex-[1] w-full">
                <div className="mb-4 w-14 h-14 bg-[#004270] rounded-lg flex items-center justify-center text-white">
                  <Contact size={24} />
                </div>
              </div>
              <div className="flex-[6] w-full">
                <div>
                  <div
                    className="[&_h4]:p-0"
                    dangerouslySetInnerHTML={{
                      __html: data.bloque25,
                    }}
                  />
                </div>
              </div>

              <div className="flex-[3] w-full bg-white/5  rounded-lg border border-white/10">
                <div
                  className="[&_p]:p-0
                      [&_p]:text-gray-500"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque26,
                  }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* COLABORACIÓN */}

        <section id="colaboracion" className=" py-24  ">
          <div className="max-w-6xl mx-auto px-6 sm:px-4 lg:px-0   ">
            <div
              className="  max-w-3xl m-auto text-center
              [&_h3]:uppercase
                [&_h3]:text-base
            
                [&_h3]:p-0
                  [&_h3_strong]:text-base
                 
                  "
              dangerouslySetInnerHTML={{
                __html: data.bloque27,
              }}
            />

            <div className="grid grid-cols-1 sm:grid-cols-2  lg:grid-cols-3 gap-6 mt-10">
              <div className="bg-gray-50 rounded-3xl p-4 border border-slate-200 ">
                <img
                  className="rounded-3xl"
                  src={data.imagen28}
                  alt="utpl"
                ></img>
                <div
                  className="mt-4"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque28,
                  }}
                />
              </div>
              <div className="bg-gray-50 rounded-3xl p-4 border border-slate-200 ">
                <img
                  className="rounded-3xl"
                  src={data.imagen29}
                  alt="utpl"
                ></img>
                <div
                  className="mt-4"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque29,
                  }}
                />
              </div>
              <div className="bg-gray-50 rounded-3xl p-4 border border-slate-200 ">
                <img
                  className="rounded-3xl"
                  src={data.imagen30}
                  alt="utpl"
                ></img>
                <div
                  className="mt-4"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque30,
                  }}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <>
      <DataFetcherTemplateHome2 url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplateHome2>{" "}
    </>
  );
}

export default Internacional;
